(function () {
    'use strict';

    angular
        .module('controlEditModule')
        .controller('ControlObservationListController', Controller);

    Controller.$inject = ['$scope', 'historyCtxtService'];

    function Controller($scope, historyCtxtService) {

        // Edit Observation
        $scope.editObservation = function (item) {
            historyCtxtService.goToState('observation.edit',
                { ObservationID: item.ObservationID },
                'control',
                $scope.control
            );
        };
    }
})();